import { EventListener } from "silver";
import { StorageKeyObserver } from "shared/StorageKeyObserver";

export class ReducedMotionPreference {

	public readonly onChange = EventListener.create<{ value: boolean }>("change");

	constructor(
		private observer: StorageKeyObserver<boolean>,
		private query: MediaQueryList = matchMedia("(prefers-reduced-motion: true)")
	) {
		observer.onChange(({ value }) => {
			if (value !== undefined) {
				this.onChange.trigger({ value });
			}
		});
		this.query.addEventListener("change", () => {
			if (this.observer.value === undefined) {
				this.onChange.trigger({ value: this.value });
			}
		});
	}

	get value(): boolean {
		return this.observer.value ?? this.query.matches;
	}

	set value(value: boolean) {
		this.observer.value = value;
	}

	public static make(): ReducedMotionPreference {
		return new ReducedMotionPreference(new StorageKeyObserver<boolean>(localStorage, "prefers-reduced-motion", {
			encode: JSON.stringify,
			decode: JSON.parse
		}));
	}
}
